export const ANALYTICS_COPY_INTERAC_CODE =
  'banking-info/ANALYTICS_COPY_INTERAC_CODE';
